import { Effect } from "../../Materials/effect";
var name = 'instancesDeclaration';
var shader = "#ifdef INSTANCES\nattribute vec4 world0;\nattribute vec4 world1;\nattribute vec4 world2;\nattribute vec4 world3;\n#ifdef THIN_INSTANCES\nuniform mat4 world;\n#endif\n#else\nuniform mat4 world;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */

export var instancesDeclaration = {
  name: name,
  shader: shader
};